import React, { useState, useEffect } from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import { Link, useNavigate } from "react-router-dom";
import SearchBox from "./components/SearchBox";
import { Table, TablePaginationConfig } from "antd";
import { useGetAdminsQuery } from "../../../hooks/AdminManagement/useGetAdminsQuery";
import Loader from "../../../Components/Loader";

type Props = {};

const AdminManagementHome = (props: Props) => {
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState<TablePaginationConfig>({
    current: 1,
    pageSize: 10,
  });

  const { data, isPending } = useGetAdminsQuery({
    id: "",
    search: search,
    page: pagination.current,
    limit: pagination.pageSize,
  });

  const navigate = useNavigate();

  useEffect(() => {
    if (data?.data?.meta) {
      setPagination((prev) => ({
        ...prev,
        total: data.data.meta.totalDocs,
      }));
    }
  }, [data?.data?.meta]);

  const handleTableChange = (newPagination: TablePaginationConfig) => {
    setPagination((prev) => ({
      ...prev,
      current: newPagination.current ?? 1,
      pageSize: newPagination.pageSize ?? 10,
    }));
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_: any, record: { firstName: string; lastName: string }) => (
        <h3 className="text-[13px]">
          {record.firstName + " " + record.lastName}
        </h3>
      ),
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      render: (phoneNumber: string | null) => (
        <span className="">{phoneNumber ? phoneNumber : "N/A"}</span>
      ),
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
      render: (email: string | null) => (
        <span className="">{email ? email : "N/A"}</span>
      ),
    },
    {
      title: "Last Login",
      dataIndex: "lastLogin",
      key: "lastLogin",
      render: (lastLogin: string | null) => (
        <span className="">
          {lastLogin ? new Date(lastLogin).toLocaleString() : "Never"}
        </span>
      ),
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (record: { name: string; colorCode: any }) => (
        <span
          className="rounded inline-block text-center text-[10px]"
          style={{
            color:
              record?.colorCode && record?.colorCode !== ""
                ? record.colorCode
                : "#333",
            padding: "6px 12px",
            backgroundColor:
              record?.colorCode && record?.colorCode !== ""
                ? `${record.colorCode}1A`
                : "#f0f0f0",
            minWidth: "80px",
            fontWeight: 500,
          }}
        >
          {record?.name === "" ? "N/A" : record?.name}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "",
      key: "action",
      render: (record: any) => <OptionIcon />,
    },
  ];

  return (
    <DashboardLayout
      title="Admin Management"
      back={false}
      right={<SearchBox setSearch={setSearch} search={search} />}
    >
      <div className="flex border-b-[1px] border-[#eeeeee] mb-3 justify-between items-center">
        <div className="flex justify-between items-center">
          <div
            className={`px-[10px] py-[13px] cursor-pointer ${
              search === "" ? "text-orange bg-[#FFF5F0]" : "text-[#a8a8a8]"
            }`}
            onClick={() => setSearch("")}
          >
            All Admins
          </div>
          <div
            className={`px-[10px] py-[13px] cursor-pointer ${
              search === "driver"
                ? "text-orange bg-[#FFF5F0]"
                : "text-[#a8a8a8]"
            }`}
            onClick={() => setSearch("driver")}
          >
            Driver
          </div>
          <div
            className={`px-[10px] py-[13px] cursor-pointer ${
              search === "deleted"
                ? "text-orange bg-[#FFF5F0]"
                : "text-[#a8a8a8]"
            }`}
            onClick={() => setSearch("deleted")}
          >
            Deleted
          </div>
        </div>
        <div className="flex gap-2 justify-between items-center pr-[40px]">
          <Link
            to="/admin-management/explore-roles"
            className="p-3 rounded-md bg-[#eeeeee] text-[#3d3d3d]"
          >
            Explore Roles
          </Link>
        </div>
      </div>
      {isPending && <Loader />}
      <div className="mt-4">
        {!isPending && data?.data && (
          <div className="flex flex-col h-full">
            <Table
              dataSource={data && data.data.docs}
              columns={columns}
              scroll={{ y: "calc(100vh - 200px)" }}
              rowKey="id"
              className="pr-[40px] pl-[20px] flex-grow"
              loading={isPending}
              pagination={pagination}
              onChange={handleTableChange}
              onRow={(record: any) => ({
                onClick: () => navigate(`/admin-management/user/${record.id}`),
              })}
            />
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default AdminManagementHome;

const OptionIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6 text-black mx-auto"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      />
    </svg>
  );
};
